const prefix = 'fac';
const iconName = 'merge';
const width = 515;
const height = 515;
const ligatures = [];
const unicode = null;
const svgPathData = 'M287 291V355H68V291H287ZM291 287V68C291 65.7909 289.209 64 287 64H68C65.7909 64 64 65.7909 64 68V287C64 289.209 65.7909 291 68 291V355C30.738 355 0.476439 325.029 0.00585938 287.879L0 287V68C1.03095e-06 30.4446 30.4446 1.03082e-06 68 0H287L287.879 0.00585938C325.029 0.476439 355 30.738 355 68V287L354.994 287.879C354.527 324.737 324.737 354.527 287.879 354.994L287 355V291C289.209 291 291 289.209 291 287Z M447 451V515H228V451H447ZM451 447V228C451 225.791 449.209 224 447 224H228C225.791 224 224 225.791 224 228V447C224 449.209 225.791 451 228 451V515C190.738 515 160.476 485.029 160.006 447.879L160 447V228C160 190.445 190.445 160 228 160H447L447.879 160.006C485.029 160.476 515 190.738 515 228V447L514.994 447.879C514.527 484.737 484.737 514.527 447.879 514.994L447 515V451C449.209 451 451 449.209 451 447Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faMerge };
